import { render, staticRenderFns } from "./ProviderPaymentList.vue?vue&type=template&id=3ae43f12&lang=pug&"
import script from "./ProviderPaymentList.vue?vue&type=script&lang=js&"
export * from "./ProviderPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderPaymentList.vue"
export default component.exports